<template>
    <div>
        <!--for overlay :loading="get_ay_std_ft_loader" -->
        <!--api- 1  -->
        <v-card v-if="fees_structure_data!=null" dense class="box">
            <!-- <v-card-text> -->
               <v-toolbar flat dense class="toolbar">
                    <v-toolbar-title>Fees Payment</v-toolbar-title>
                    <v-divider class="mx-4" inset vertical></v-divider>
                    <v-spacer></v-spacer>
                </v-toolbar>
                <!-- <v-row justify="center" dense>
                    <v-col sm="3">
                        <h3>Fees Payment</h3>
                    </v-col>
                </v-row> -->
                <v-row justify="center" dense>
                <v-radio-group v-model="gr_form" row dense>
                    <v-radio label="PRN No" value="GRNO"></v-radio>
                    <v-radio label="Form No" value="FORM"></v-radio>
                </v-radio-group>
                </v-row>
                <v-row justify="center" dense>
                    <v-col sm="2">
                        <v-icon color="error">*</v-icon>
                        <v-text-field outlined rounded dense v-model="grno_or_app_form_no" :label="label_grno_or_app_form_no" type="text" hint="For example :: 121/111"></v-text-field>
                    </v-col>
                    <v-col sm="2">
                        <v-icon color="error">*</v-icon>
                        <v-combobox rounded dense required v-model="current_academic_year" :items="fees_structure_data.academic_year_list" item-text="Academic Year" label="Academic Year" outlined />
                    </v-col>
                    <v-col sm="2">
                        <v-icon color="error">*</v-icon>
                        <v-combobox dense required v-model="fees_type" rounded :items="fees_structure_data.fees_deposite_type" item-text="Fees Type" label="Fees Type" outlined />
                    </v-col>
                    <v-col sm="2">
                        <v-btn class="mt-6 button"  @click="callSpecificFees" :loading="proceed_btn_load">Proceed</v-btn>
                    </v-col>
                </v-row>
            <!-- </v-card-text> -->
        </v-card>
        <!-- api-1 ends -->
        <!-- <template v-if="fees_type_comp!=null">
        <router-view/>
    </template> -->
        <!-- <br /> -->
        <component v-bind:is="fees_type_comp" v-if="fees_type_comp!=null"></component>
    </div>
</template>
<script>
    import axios from "axios";
    import AdmissionFees from "./AdmissionFees";
    import HostelFees from "./HostelFees";
    import "@/assets/css/color.css"; // css needs to be imported for each dashboard
    export default {
        components: {
            "admission-fees-comp": AdmissionFees,
            "hostel-fees-comp": HostelFees,
        },
        data: () => ({
            //1
            fees_structure_data: null,
            current_academic_year: null,
            fees_type: null,
            grno_or_app_form_no: 0,
            gr_form: null,
            label_grno_or_app_form_no: "PRN No/Form No",
            //2
            fees_type_comp: null,
            //loader
            get_ay_std_ft_loader: true,
            proceed_btn_load: false,
        }),
        watch: {
            gr_form() {
                if (this.gr_form == "GRNO") {
                    this.label_grno_or_app_form_no = "PRN No";
                } else if (this.gr_form == "FORM") {
                    this.label_grno_or_app_form_no = "Form No";
                } else {
                    this.label_grno_or_app_form_no = "PRN No/Form No";
                }
            },
        },
        methods: {
            //api-2
            callSpecificFees() {
                //this.$router.push({name:'fees-payment'})
                this.fees_type_comp = null;
                const formData = {
                    grno_or_app_form_no: this.grno_or_app_form_no,
                    fees_type: this.fees_type,
                    gr_form: this.gr_form,
                    ay: this.current_academic_year,
                };
                this.$store.commit("setdata_for_fees", formData);
                if (this.fees_type == "Admission Fees") {
                    this.fees_type_comp = "admission-fees-comp";
                    //  this.$router.push({name:'admission-fees'})
                } else if (this.fees_type == "Hostel Fees") {
                    this.fees_type_comp = "hostel-fees-comp";
                    //this.$router.push({name:'hostel-fees'})
                } else this.fees_type_comp = null;
            },
            get_ay_std_ft() {
                //api-1
                this.get_ay_std_ft_loader = true;
                axios
                    .post("/feesMaster/get_ay_std_ft")
                    .then((res) => {
                        if (res.data.msg == "200") {
                            this.fees_structure_data = res.data.fees_structure_data;
                            this.current_academic_year = res.data.fees_structure_data.current_academic_year;
                            this.fees_type = this.fees_structure_data.fees_deposite_type[0];
                        } else {
                            //error
                        }
                    })
                    .catch((error) => {
                        window.console.log(error);
                    })
                    .finally(() => {
                        //close loader
                        this.get_ay_std_ft_loader = false;
                    });
            },
        },
        mounted() {
            this.gr_form = "FORM";
            this.get_ay_std_ft();
        },
    };
</script>
